// extracted by mini-css-extract-plugin
export default {"avatar":"wPG4Q7","withBorder":"dLanqj","filter":"uYHak7"};